import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class PropertyProfile
 *
 * @property {number} id
 */
export class PropertyProfile extends Model {


}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'type',
    'country_id',
    'country',
    'city_id',
    'city',
    'postal_code',
    'address',
    'contact_person_name',
    'contact_emails',
    'contact_phones',
)(PropertyProfile);



// WEBPACK FOOTER //
// ./src/pms-api/models/property-profile.model.js